<template>
    <div v-if="hasChat" class="req-chat">
        <div v-if="summary" class="req-chat-summary">{{ summary }}</div>
        <div class="req-chat-thread">
            <div
                v-for="(msg, index) in messages"
                :key="index"
                class="req-chat-row"
                :class="msg.role === 'user' ? 'is-user' : 'is-bot'"
            >
                <div class="req-chat-label">{{ msg.role === 'user' ? 'User' : 'Bot' }}</div>
                <div class="req-chat-bubble">{{ msg.text }}</div>
            </div>
        </div>
    </div>
    <div v-else class="req-plain" style="white-space: pre-wrap;">{{ text || '—' }}</div>
</template>

<script>
export default {
    name: 'SpecificRequirementsDisplay',
    props: {
        text: {
            type: String,
            default: '',
        },
    },
    computed: {
        parsed() {
            const raw = (this.text || '').trim();
            if (!raw) {
                return { summary: '', messages: [] };
            }

            const chatMarker = raw.search(/(^|\n)Chat:\s*\n/i);
            let summary = raw;
            let chatBody = '';

            if (chatMarker >= 0) {
                const match = raw.match(/(^|\n)Chat:\s*\n/i);
                const start = chatMarker + (match && match[1] ? match[1].length : 0);
                const afterLabel = raw.indexOf('\n', start);
                summary = raw.slice(0, chatMarker).trim();
                chatBody = afterLabel >= 0 ? raw.slice(afterLabel + 1).trim() : '';
            } else if (/^(Bot|User)\s*:/im.test(raw)) {
                summary = '';
                chatBody = raw;
            } else {
                return { summary: '', messages: [] };
            }

            const messages = [];
            const parts = chatBody.split(/\n(?=(?:Bot|User)\s*:)/i);
            for (const part of parts) {
                const m = part.match(/^(Bot|User)\s*:\s*([\s\S]*)$/i);
                if (!m) {
                    continue;
                }
                const text = (m[2] || '').trim();
                if (!text) {
                    continue;
                }
                messages.push({
                    role: m[1].toLowerCase() === 'user' ? 'user' : 'bot',
                    text,
                });
            }

            return { summary, messages };
        },
        summary() {
            return this.parsed.summary;
        },
        messages() {
            return this.parsed.messages;
        },
        hasChat() {
            return this.messages.length > 0;
        },
    },
};
</script>

<style scoped>
.req-chat-summary {
    margin-bottom: 10px;
    color: #606266;
    font-size: 13px;
    white-space: pre-wrap;
}

.req-chat-thread {
    max-height: 360px;
    overflow-y: auto;
    padding: 8px;
    background: #f5f7fa;
    border-radius: 8px;
}

.req-chat-row {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    max-width: 85%;
}

.req-chat-row.is-bot {
    align-items: flex-start;
    margin-right: auto;
}

.req-chat-row.is-user {
    align-items: flex-end;
    margin-left: auto;
}

.req-chat-label {
    font-size: 11px;
    color: #909399;
    margin-bottom: 2px;
}

.req-chat-bubble {
    padding: 8px 12px;
    border-radius: 12px;
    font-size: 13px;
    line-height: 1.45;
    white-space: pre-wrap;
    word-break: break-word;
}

.req-chat-row.is-bot .req-chat-bubble {
    background: #ffffff;
    border: 1px solid #e4e7ed;
    border-bottom-left-radius: 4px;
}

.req-chat-row.is-user .req-chat-bubble {
    background: #409eff;
    color: #fff;
    border-bottom-right-radius: 4px;
}
</style>
